// // import React from "react";
// // import {
// //   FiMail,
// //   FiPhone,
// //   FiMapPin,
// //   FiClock,
// //   FiSend,
// //   FiCheckCircle,
// // } from "react-icons/fi";
// // import { motion } from "framer-motion";
// // import checklist from "../components/Checklist.jpg";

// // // Map to Mumbai (adjust as needed)
// // const OFFICE_LOCATION =
// //   "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d120201.92756512847!2d72.77242501911398!3d19.082197839710848!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7b63a7a0c6ebf%3A0x8652dc65c03119e2!2sMumbai%2C%20Maharashtra!5e0!3m2!1sen!2sin!4v1689844478916!5m2!1sen!2sin";

// // // Contact methods data
// // const contactMethods = [
// //   {
// //     icon: <FiMail className="text-yellow-600" size={26} />,
// //     title: "Email Us",
// //     details: ["sundeepsingh12478@gmail.com"],
// //     action: "mailto:sundeepsingh12478@gmail.com",
// //   },
// //   {
// //     icon: <FiPhone className="text-yellow-600" size={26} />,
// //     title: "Call Us",
// //     details: ["+91 88xxxxx,"],
// //     action: "tel:8828357920,",
// //   },
// //   {
// //     icon: <FiMapPin className="text-yellow-600" size={26} />,
// //     title: "Visit Us",
// //     details: [
// //       " 2A43 Nalanda Complex, Evershine Nagar",
// //       "Malad West, Mumbai - 400064",
// //       "Maharashtra, India",
// //     ],
// //     action: "https://goo.gl/maps/SOMEVALIDMAP",
// //   },
// //   {
// //     icon: <FiClock className="text-yellow-600" size={26} />,
// //     title: "Working Hours",
// //     details: [
// //       "Mon-Fri: 10am - 7pm IST",
// //       "Sat: 10am - 2pm IST",
// //       "Sunday: Closed",
// //     ],
// //     action: null,
// //   },
// // ];

// // // Animation variants for fade-in
// // const fadeIn = {
// //   hidden: { opacity: 0, y: 40 },
// //   visible: { opacity: 1, y: 0, transition: { duration: 0.7 } },
// // };

// // const ContactPage = () => {
// //   return (
// //     <div className="font-sans text-gray-800 bg-gradient-to-br from-yellow-50 via-white to-blue-50 min-h-screen">
// //       {/* HERO SECTION */}

// //       {/* CONTACT METHODS */}
// //       {/* <section className="py-16 px-6 bg-white/95 mt-[-3rem] relative z-10 rounded-t-3xl shadow-inner">
// //         <div className="container mx-auto max-w-7xl">
// //           <motion.div
// //             initial="hidden"
// //             whileInView="visible"
// //             viewport={{ once: true }}
// //             variants={fadeIn}
// //             className="grid md:grid-cols-2 lg:grid-cols-4 gap-10"
// //           >
// //             {contactMethods.map((method, index) => (
// //               <motion.div
// //                 key={index}
// //                 whileHover={{ y: -7, boxShadow: "0 2px 24px #fde68a" }}
// //                 className="bg-gradient-to-t from-yellow-50 via-white to-blue-50 p-8 rounded-2xl border border-yellow-100 hover:border-yellow-300 transition group shadow-md flex flex-col items-center text-center"
// //               >
// //                 <div className="mb-4">{method.icon}</div>
// //                 <h3 className="text-xl font-bold mb-2 text-blue-800">
// //                   {method.title}
// //                 </h3>
// //                 <ul className="space-y-2 mb-4">
// //                   {method.details.map((d, i) => (
// //                     <li key={i} className="text-gray-700">
// //                       {d}
// //                     </li>
// //                   ))}
// //                 </ul>
// //                 {method.action && (
// //                   <a
// //                     href={method.action}
// //                     target="_blank"
// //                     rel="noopener noreferrer"
// //                     className="text-yellow-700 font-medium hover:underline flex items-center justify-center gap-1"
// //                   >
// //                     Contact Now <FiSend />
// //                   </a>
// //                 )}
// //               </motion.div>
// //             ))}
// //           </motion.div>
// //         </div>
// //       </section>
// //  */}

// //       {/* CONTACT FORM + ILLUSTRATION */}
// //       <section className="py-20 px-6 bg-gradient-to-br from-yellow-50 to-white">
// //         <div className="container mx-auto max-w-4xl">
// //           <motion.div
// //             initial="hidden"
// //             whileInView="visible"
// //             variants={fadeIn}
// //             viewport={{ once: true }}
// //             className="bg-white rounded-2xl shadow-2xl overflow-hidden flex flex-col md:flex-row"
// //           >
// //             {/* Illustration */}
// //             <motion.div
// //               initial={{ opacity: 0, x: -55 }}
// //               whileInView={{ opacity: 1, x: 0 }}
// //               viewport={{ once: true }}
// //               transition={{ type: "spring", duration: 0.9, bounce: 0.28 }}
// //               className="md:w-2/5 bg:[#aea9ff]  text-blackss p-9 flex flex-col justify-center relative items-center"
// //             >
// //               <h2 className="text-2xl font-bold mb-3">Message Our Team</h2>
// //               <p className="mb-5 opacity-95">
// //                 Fill in your details – you’ll get a reply from our Indian office
// //                 within 24 hours.
// //               </p>
// //               <motion.img
// //                 src={checklist}
// //                 alt="Contact illustration"
// //                 className="mt-4 max-w-[240px] mx-auto md:mx-0 drop-shadow-xl rounded-lg"
// //                 initial={{ opacity: 0, scale: 0.93 }}
// //                 whileInView={{ opacity: 1, scale: 1 }}
// //                 transition={{ type: "spring", duration: 0.7, delay: 0.2 }}
// //               />
// //             </motion.div>

// //             {/* Form */}
// //             <div className="md:w-3/5 p-8 bg-white">
// //               <form
// //                 className="space-y-4"
// //                 action="https://formsubmit.co/sundeepsingh12478@gmail.com"
// //                 method="POST"
// //               >
// //                 <div className="grid md:grid-cols-2 gap-4">
// //                   <div>
// //                     <label className="block text-gray-700 mb-2">
// //                       First Name*
// //                     </label>
// //                     <input
// //                       required
// //                       type="text"
// //                       name="first_name"
// //                       className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 #aea9ff #aea9ff"
// //                     />
// //                   </div>
// //                   <div>
// //                     <label className="block text-gray-700 mb-2">
// //                       Last Name*
// //                     </label>
// //                     <input
// //                       required
// //                       type="text"
// //                       name="last_name"
// //                       className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 #aea9ff"
// //                     />
// //                   </div>
// //                 </div>
// //                 <div>
// //                   <label className="block text-gray-700 mb-2">Email*</label>
// //                   <input
// //                     required
// //                     type="email"
// //                     name="email"
// //                     className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 #aea9ff"
// //                   />
// //                 </div>
// //                 <div>
// //                   <label className="block text-gray-700 mb-2">Phone</label>
// //                   <input
// //                     type="tel"
// //                     name="phone"
// //                     className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 #aea9ff"
// //                   />
// //                 </div>
// //                 <div>
// //                   <label className="block text-gray-700 mb-2">Subject*</label>
// //                   <select
// //                     required
// //                     name="subject"
// //                     className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 #aea9ff"
// //                   >
// //                     {/* <option value="">Select a subject</option>
// //                     <option>General Inquiry</option>
// //                     <option>Sales Question</option>
// //                     <option>Technical Support</option>
// //                     <option>Partnership</option>
// //                     <option>Other</option> */}
// //                   </select>
// //                 </div>
// //                 <div>
// //                   <label className="block text-gray-700 mb-2">Message*</label>
// //                   <textarea
// //                     required
// //                     rows="4"
// //                     name="message"
// //                     className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 #aea9ff"
// //                   ></textarea>
// //                 </div>

// //                 {/* Honeypot to prevent spam */}
// //                 <input type="text" name="_honey" style={{ display: "none" }} />
// //                 {/* Disable CAPTCHA */}
// //                 <input type="hidden" name="_captcha" value="false" />
// //                 {/* Optional: Redirect on success */}
// //                 {/* <input type="hidden" name="_next" value="https://yourdomain.com/thank-you" /> */}

// //                 <motion.button
// //                   whileHover={{ scale: 1.03 }}
// //                   whileTap={{ scale: 0.97 }}
// //                   type="submit"
// //                   className="w-full bg-#aea9ff hover:bg-#aea9ff text-blue-900 py-3 rounded-lg font-semibold flex items-center justify-center shadow"
// //                 >
// //                   Send Message <FiSend className="ml-2" />
// //                 </motion.button>
// //               </form>
// //             </div>
// //           </motion.div>
// //         </div>
// //       </section>

// //       {/* LOCATION MAP */}
// //       <section className="py-16 px-6 bg-white border-t border-b border-gray-100">
// //         <div className="container mx-auto max-w-6xl">
// //           <motion.div
// //             initial="hidden"
// //             whileInView="visible"
// //             variants={fadeIn}
// //             viewport={{ once: true }}
// //             className="text-center mb-10"
// //           >
// //             <h2 className="text-3xl font-bold mb-3 text-yellow-700">
// //               Our Office in Mumbai
// //             </h2>
// //             <p className="text-lg text-gray-600 max-w-3xl mx-auto">
// //               Visit us at our Bandra West HQ or connect remotely—our doors are
// //               open for pan-India brands.
// //             </p>
// //           </motion.div>
// //           <div className="rounded-xl overflow-hidden shadow-xl border border-yellow-100">
// //             <iframe
// //               src={OFFICE_LOCATION}
// //               width="100%"
// //               height="430"
// //               style={{ border: 0 }}
// //               allowFullScreen=""
// //               loading="lazy"
// //               title="Mumbai Office Location Map"
// //               className="rounded-xl min-w-full min-h-[340px]"
// //             ></iframe>
// //           </div>
// //         </div>
// //       </section>
// //     </div>
// //   );
// // };

// // export default ContactPage;

// import React from "react";
// import { FiMail, FiPhone, FiMapPin, FiClock, FiSend } from "react-icons/fi";
// import { motion } from "framer-motion";
// import checklist from "../components/Checklist.jpg";

// // Map to Mumbai (adjust as needed)
// const OFFICE_LOCATION =
//   "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d120201.92756512847!2d72.77242501911398!3d19.082197839710848!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7b63a7a0c6ebf%3A0x8652dc65c03119e2!2sMumbai%2C%20Maharashtra!5e0!3m2!1sen!2sin!4v1689844478916!5m2!1sen!2sin";

// // Contact methods data
// const contactMethods = [
//   {
//     icon: <FiMail className="text-yellow-600" size={26} />,
//     title: "Email Us",
//     details: ["sundeepsingh12478@gmail.com"],
//     action: "mailto:sundeepsingh12478@gmail.com",
//   },
//   {
//     icon: <FiPhone className="text-yellow-600" size={26} />,
//     title: "Call Us",
//     details: ["+91 88xxxxx,"],
//     action: "tel:8828357920,",
//   },
//   {
//     icon: <FiMapPin className="text-yellow-600" size={26} />,
//     title: "Visit Us",
//     details: [
//       " 2A43 Nalanda Complex, Evershine Nagar",
//       "Malad West, Mumbai - 400064",
//       "Maharashtra, India",
//     ],
//     action: "https://goo.gl/maps/SOMEVALIDMAP",
//   },
//   {
//     icon: <FiClock className="text-yellow-600" size={26} />,
//     title: "Working Hours",
//     details: [
//       "Mon-Fri: 10am - 7pm IST",
//       "Sat: 10am - 2pm IST",
//       "Sunday: Closed",
//     ],
//     action: null,
//   },
// ];

// // Animation variants for fade-in
// const fadeIn = {
//   hidden: { opacity: 0, y: 40 },
//   visible: { opacity: 1, y: 0, transition: { duration: 0.7 } },
// };

// const ContactPage = () => {
//   return (
//     <div className="font-sans text-gray-800 bg-gradient-to-br from-yellow-50 via-white to-blue-50 min-h-screen">
//       {/* HERO SECTION */}
//       {/* Note: Hero section was not provided in the original code, so it's left as a comment */}

//       {/* CONTACT METHODS */}
//       {/* <section className="py-16 px-6 bg-white/95 mt-[-3rem] relative z-10 rounded-t-3xl shadow-inner">
//         <div className="container mx-auto max-w-7xl">
//           <motion.div
//             initial="hidden"
//             whileInView="visible"
//             viewport={{ once: true }}
//             variants={fadeIn}
//             className="grid md:grid-cols-2 lg:grid-cols-4 gap-10"
//           >
//             {contactMethods.map((method, index) => (
//               <motion.div
//                 key={index}
//                 whileHover={{ y: -7, boxShadow: "0 2px 24px #fde68a" }}
//                 className="bg-gradient-to-t from-yellow-50 via-white to-blue-50 p-8 rounded-2xl border border-yellow-100 hover:border-yellow-300 transition group shadow-md flex flex-col items-center text-center"
//               >
//                 <div className="mb-4">{method.icon}</div>
//                 <h3 className="text-xl font-bold mb-2 text-blue-800">
//                   {method.title}
//                 </h3>
//                 <ul className="space-y-2 mb-4">
//                   {method.details.map((d, i) => (
//                     <li key={i} className="text-gray-700">
//                       {d}
//                     </li>
//                   ))}
//                 </ul>
//                 {method.action && (
//                   <a
//                     href={method.action}
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     className="text-yellow-700 font-medium hover:underline flex items-center justify-center gap-1"
//                   >
//                     Contact Now <FiSend />
//                   </a>
//                 )}
//               </motion.div>
//             ))}
//           </motion.div>
//         </div>
//       </section> */}

//       {/* CONTACT FORM + ILLUSTRATION */}
//       <section className="py-20 px-6 bg-gradient-to-br from-yellow-50 to-white">
//         <div className="container mx-auto max-w-4xl">
//           <motion.div
//             initial="hidden"
//             whileInView="visible"
//             variants={fadeIn}
//             viewport={{ once: true }}
//             className="bg-white rounded-2xl shadow-2xl overflow-hidden flex flex-col md:flex-row"
//           >
//             {/* Illustration */}
//             <motion.div
//               initial={{ opacity: 0, x: -55 }}
//               whileInView={{ opacity: 1, x: 0 }}
//               viewport={{ once: true }}
//               transition={{ type: "spring", duration: 0.9, bounce: 0.28 }}
//               className="md:w-2/5 bg-blue-600 text-white p-9 flex flex-col justify-center relative items-center"
//             >
//               <h2 className="text-2xl font-bold mb-3">Message Our Team</h2>
//               <p className="mb-5 opacity-95">
//                 Fill in your details – you’ll get a reply from our Indian office
//                 within 24 hours.
//               </p>
//               <motion.img
//                 src={checklist}
//                 alt="Contact illustration"
//                 className="mt-4 max-w-[240px] mx-auto md:mx-0 drop-shadow-xl rounded-lg"
//                 initial={{ opacity: 0, scale: 0.93 }}
//                 whileInView={{ opacity: 1, scale: 1 }}
//                 transition={{ type: "spring", duration: 0.7, delay: 0.2 }}
//               />
//             </motion.div>

//             {/* Form */}
//             <div className="md:w-3/5 p-8 bg-white">
//               <form
//                 className="space-y-4"
//                 action="https://formsubmit.co/sundeepsingh12478@gmail.com"
//                 method="POST"
//               >
//                 <div className="grid md:grid-cols-2 gap-4">
//                   <div>
//                     <label className="block text-gray-700 mb-2">
//                       First Name*
//                     </label>
//                     <input
//                       required
//                       type="text"
//                       name="first_name"
//                       className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-600"
//                     />
//                   </div>
//                   <div>
//                     <label className="block text-gray-700 mb-2">
//                       Last Name*
//                     </label>
//                     <input
//                       required
//                       type="text"
//                       name="last_name"
//                       className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-600"
//                     />
//                   </div>
//                 </div>
//                 <div>
//                   <label className="block text-gray-700 mb-2">Email*</label>
//                   <input
//                     required
//                     type="email"
//                     name="email"
//                     className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-600"
//                   />
//                 </div>
//                 <div>
//                   <label className="block text-gray-700 mb-2">Phone</label>
//                   <input
//                     type="tel"
//                     name="phone"
//                     className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-600"
//                   />
//                 </div>
//                 <div>
//                   <label className="block text-gray-700 mb-2">Subject*</label>
//                   <select
//                     required
//                     name="subject"
//                     className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-600"
//                   >
//                     <option value="">Select a subject</option>
//                     <option>General Inquiry</option>
//                     <option>Sales Question</option>
//                     <option>Technical Support</option>
//                     <option>Partnership</option>
//                     <option>Other</option>
//                   </select>
//                 </div>
//                 <div>
//                   <label className="block text-gray-700 mb-2">Message*</label>
//                   <textarea
//                     required
//                     rows="4"
//                     name="message"
//                     className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-600"
//                   ></textarea>
//                 </div>

//                 {/* Honeypot to prevent spam */}
//                 <input type="text" name="_honey" style={{ display: "none" }} />
//                 {/* Disable CAPTCHA */}
//                 <input type="hidden" name="_captcha" value="false" />
//                 {/* Optional: Redirect on success */}
//                 {/* <input type="hidden" name="_next" value="https://yourdomain.com/thank-you" /> */}

//                 <motion.button
//                   whileHover={{ scale: 1.03 }}
//                   whileTap={{ scale: 0.97 }}
//                   type="submit"
//                   className="w-full bg-blue-600 hover:bg-blue-700 text-white py-3 rounded-lg font-semibold flex items-center justify-center shadow"
//                 >
//                   Send Message <FiSend className="ml-2" />
//                 </motion.button>
//               </form>
//             </div>
//           </motion.div>
//         </div>
//       </section>

//       {/* LOCATION MAP */}
//       <section className="py-16 px-6 bg-white border-t border-b border-gray-100">
//         <div className="container mx-auto max-w-6xl">
//           <motion.div
//             initial="hidden"
//             whileInView="visible"
//             variants={fadeIn}
//             viewport={{ once: true }}
//             className="text-center mb-10"
//           >
//             <h2 className="text-3xl font-bold mb-3 text-yellow-700">
//               Our Office in Mumbai
//             </h2>
//             <p className="text-lg text-gray-600 max-w-3xl mx-auto">
//               Visit us at our Bandra West HQ or connect remotely—our doors are
//               open for pan-India brands.
//             </p>
//           </motion.div>
//           <div className="rounded-xl overflow-hidden shadow-xl border border-yellow-100">
//             <iframe
//               src={OFFICE_LOCATION}
//               width="100%"
//               height="430"
//               style={{ border: 0 }}
//               allowFullScreen=""
//               loading="lazy"
//               title="Mumbai Office Location Map"
//               className="rounded-xl min-w-full min-h-[340px]"
//             ></iframe>
//           </div>
//         </div>
//       </section>
//     </div>
//   );
// };

// export default ContactPage;

import React from "react";
import { FiMail, FiPhone, FiMapPin, FiClock, FiSend } from "react-icons/fi";
import { motion } from "framer-motion";
import checklist from "../components/Checklist.jpg";

// Map to Mumbai (adjust as needed)
const OFFICE_LOCATION =
  "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d120201.92756512847!2d72.77242501911398!3d19.082197839710848!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7b63a7a0c6ebf%3A0x8652dc65c03119e2!2sMumbai%2C%20Maharashtra!5e0!3m2!1sen!2sin!4v1689844478916!5m2!1sen!2sin";

// Contact methods data
const contactMethods = [
  {
    icon: <FiMail className="text-yellow-600" size={26} />,
    title: "Email Us",
    details: ["sundeepsingh12478@gmail.com"],
    action: "mailto:sundeepsingh12478@gmail.com",
  },
  {
    icon: <FiPhone className="text-yellow-600" size={26} />,
    title: "Call Us",
    details: ["+91 88xxxxx,"],
    action: "tel:8828357920,",
  },
  {
    icon: <FiMapPin className="text-yellow-600" size={26} />,
    title: "Visit Us",
    details: [
      " 2A43 Nalanda Complex, Evershine Nagar",
      "Malad West, Mumbai - 400064",
      "Maharashtra, India",
    ],
    action: "https://goo.gl/maps/SOMEVALIDMAP",
  },
  {
    icon: <FiClock className="text-yellow-600" size={26} />,
    title: "Working Hours",
    details: [
      "Mon-Fri: 10am - 7pm IST",
      "Sat: 10am - 2pm IST",
      "Sunday: Closed",
    ],
    action: null,
  },
];

// Animation variants for fade-in
const fadeIn = {
  hidden: { opacity: 0, y: 40 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.7 } },
};

const ContactPage = () => {
  return (
    <div className="font-sans text-gray-800 bg-gradient-to-br from-yellow-50 via-white to-blue-50 min-h-screen">
      {/* HERO SECTION */}
      {/* Note: Hero section was not provided in the original code, so it's left as a comment */}

      {/* CONTACT METHODS */}
      {/* <section className="py-16 px-6 bg-white/95 mt-[-3rem] relative z-10 rounded-t-3xl shadow-inner">
        <div className="container mx-auto max-w-7xl">
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={fadeIn}
            className="grid md:grid-cols-2 lg:grid-cols-4 gap-10"
          >
            {contactMethods.map((method, index) => (
              <motion.div
                key={index}
                whileHover={{ y: -7, boxShadow: "0 2px 24px #fde68a" }}
                className="bg-gradient-to-t from-yellow-50 via-white to-blue-50 p-8 rounded-2xl border border-yellow-100 hover:border-yellow-300 transition group shadow-md flex flex-col items-center text-center"
              >
                <div className="mb-4">{method.icon}</div>
                <h3 className="text-xl font-bold mb-2 text-blue-800">
                  {method.title}
                </h3>
                <ul className="space-y-2 mb-4">
                  {method.details.map((d, i) => (
                    <li key={i} className="text-gray-700">
                      {d}
                    </li>
                  ))}
                </ul>
                {method.action && (
                  <a
                    href={method.action}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-yellow-700 font-medium hover:underline flex items-center justify-center gap-1"
                  >
                    Contact Now <FiSend />
                  </a>
                )}
              </motion.div>
            ))}
          </motion.div>
        </div>
      </section> */}

      {/* CONTACT FORM + ILLUSTRATION */}
      <section className="py-20 px-6 bg-gradient-to-br from-yellow-50 to-white">
        <div className="container mx-auto max-w-4xl">
          <motion.div
            initial="hidden"
            whileInView="visible"
            variants={fadeIn}
            viewport={{ once: true }}
            className="bg-white rounded-2xl shadow-2xl overflow-hidden flex flex-col md:flex-row"
          >
            {/* Illustration */}
            <motion.div
              initial={{ opacity: 0, x: -55 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ type: "spring", duration: 0.9, bounce: 0.28 }}
              className="md:w-2/5 bg-blue-600 text-white p-9 flex flex-col justify-center relative items-center"
            >
              <h2 className="text-2xl font-bold mb-3">Message Our Team</h2>
              <p className="mb-5 opacity-95">
                Fill in your details – you’ll get a reply within 24 hours.
              </p>
              <motion.img
                src={checklist}
                alt="Contact illustration"
                className="mt-4 max-w-[240px] mx-auto md:mx-0 drop-shadow-xl rounded-lg"
                initial={{ opacity: 0, scale: 0.93 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ type: "spring", duration: 0.7, delay: 0.2 }}
              />
            </motion.div>

            {/* Form */}
            <div className="md:w-3/5 p-8 bg-white">
              <form
                className="space-y-4"
                action="https://formsubmit.co/sundeepsingh12478@gmail.com"
                method="POST"
              >
                <div className="grid md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-gray-700 mb-2">
                      First Name*
                    </label>
                    <input
                      required
                      type="text"
                      name="first_name"
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-600"
                    />
                  </div>
                  <div>
                    <label className="block text-gray-700 mb-2">
                      Last Name*
                    </label>
                    <input
                      required
                      type="text"
                      name="last_name"
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-600"
                    />
                  </div>
                </div>
                <div>
                  <label className="block text-gray-700 mb-2">Email*</label>
                  <input
                    required
                    type="email"
                    name="email"
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-600"
                  />
                </div>
                <div>
                  <label className="block text-gray-700 mb-2">Phone</label>
                  <input
                    type="tel"
                    name="phone"
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-600"
                  />
                </div>
                <div>
                  <label className="block text-gray-700 mb-2">Subject*</label>
                  <input
                    required
                    type="text"
                    name="subject"
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-600"
                  />
                </div>
                <div>
                  <label className="block text-gray-700 mb-2">Message*</label>
                  <textarea
                    required
                    rows="4"
                    name="message"
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-600"
                  ></textarea>
                </div>

                {/* Honeypot to prevent spam */}
                <input type="text" name="_honey" style={{ display: "none" }} />
                {/* Disable CAPTCHA */}
                <input type="hidden" name="_captcha" value="false" />
                {/* Optional: Redirect on success */}
                {/* <input type="hidden" name="_next" value="https://yourdomain.com/thank-you" /> */}

                <motion.button
                  whileHover={{ scale: 1.03 }}
                  whileTap={{ scale: 0.97 }}
                  type="submit"
                  className="w-full bg-blue-600 hover:bg-blue-700 text-white py-3 rounded-lg font-semibold flex items-center justify-center shadow"
                >
                  Send Message <FiSend className="ml-2" />
                </motion.button>
              </form>
            </div>
          </motion.div>
        </div>
      </section>

      {/* LOCATION MAP */}
      <section className="py-16 px-6 bg-white border-t border-b border-gray-100">
        <div className="container mx-auto max-w-6xl">
          <motion.div
            initial="hidden"
            whileInView="visible"
            variants={fadeIn}
            viewport={{ once: true }}
            className="text-center mb-10"
          >
            <h2 className="text-3xl font-bold mb-3 text-yellow-700">
              Our Office in Mumbai
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Visit us at our Bandra West HQ or connect remotely—our doors are
              open for brands across Globe.
            </p>
          </motion.div>
          <div className="rounded-xl overflow-hidden shadow-xl border border-yellow-100">
            <iframe
              src={OFFICE_LOCATION}
              width="100%"
              height="430"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              title="Mumbai Office Location Map"
              className="rounded-xl min-w-full min-h-[340px]"
            ></iframe>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContactPage;
